export { version } from './package.json';
export * from './src/utils';



// WEBPACK FOOTER //
// ./d:/dbs/el/aapusc/private/client-react/packages/hoc-utils/index.js